<template>
  <div>
    <!-- 搜索框与添加按钮 -->
    <el-row :gutter="20" style="margin-bottom: 20px">
      <el-col :span="8">
        <el-input v-model="state.searchForm.userName" placeholder="输入用户名" clearable></el-input>
      </el-col>
      <el-col :span="8">
        <el-select v-model="state.searchForm.role" placeholder="选择角色" clearable>
          <el-option label="管理员" value="管理员"></el-option>
          <el-option label="学员" value="学员"></el-option>
        </el-select>
      </el-col>
      <el-col :span="8" style="text-align: right">
        <el-button type="primary" @click="fetchData">搜索</el-button>
        <el-button type="primary" @click="showAddUserDialog" icon="el-icon-plus" style="margin-left: 10px">添加用户</el-button>
      </el-col>
    </el-row>

    <!-- 用户列表表格 -->
    <el-table :data="state.users" style="width: 100%" stripe>
      <el-table-column label="用户名" prop="userName" width="150"></el-table-column>
      <el-table-column label="角色" prop="role" width="120"></el-table-column>

      <!-- 密码列，增加查看密码的按钮 -->
<!--      <el-table-column label="密码" prop="password" width="200">-->
<!--        <template #default="{ row }">-->
<!--          <el-button type="text" @click="togglePasswordVisibility(row)">-->
<!--            {{ row.passwordVisible ? row.password : '******' }}-->
<!--          </el-button>-->
<!--        </template>-->
<!--      </el-table-column>-->

      <!-- 新增：展示人脸图片 -->
      <el-table-column label="人脸图片" width="180">
        <template #default="{ row }">
          <!-- 如果有 faceImageUrl，则显示图片，否则显示占位图 -->
          <img v-if="row.faceImageUrl" :src="row.faceImageUrl" alt="Face" style="width: 50px; height: 50px; border-radius: 50%;" />
          <span v-else>无图片</span>
        </template>
      </el-table-column>

      <el-table-column label="操作" width="200">
        <template #default="{ row }">
          <el-button type="text" @click="editUser(row)">编辑</el-button>
          <el-button type="text" @click="deleteUser(row)">删除</el-button>
          <el-button type="text" @click="resetpassword(row)">重置密码</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <el-pagination
        v-if="state.totalCount > 0"
        :current-page="state.currentPage"
        :page-size="state.pageSize"
        :total="state.totalCount"
        layout="total, prev, pager, next, jumper"
        @current-change="handlePageChange"
    ></el-pagination>

    <!-- 用户添加/编辑对话框 -->
    <el-dialog v-model="state.dialogVisible" title="添加/编辑用户">
      <el-form :model="state.userForm" ref="userFormRef" label-width="100px">
        <el-form-item label="用户名" prop="userName" :rules="[{ required: true, message: '请输入用户名', trigger: 'blur' }]">
          <el-input v-model="state.userForm.userName" placeholder="请输入用户名"></el-input>
        </el-form-item>

        <el-form-item label="密码" prop="password" disabled :rules="[{ required: true, message: '请输入密码', trigger: 'blur' }]">
          <el-input type="password" disabled v-model="state.userForm.password" placeholder="请输入密码"></el-input>
        </el-form-item>

        <el-form-item label="角色">
          <el-select v-model="state.userForm.role" placeholder="选择角色">
            <el-option label="机构管理员" value="机构管理员"></el-option>
            <el-option label="学员" value="学员"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="saveUser">保存</el-button>
          <el-button @click="state.dialogVisible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import axios from "@/axios";
import { ElMessage } from "element-plus";

export default {
  props: {
    userid: {
      type: Number,
      required: true,
    },
    organizationID: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      isedit: false,
      state: {
        users: [],
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        searchForm: {
          userName: "",
          role: "",
        },
        userForm: {
          userName: "",
          password: "",
          role: "",
          faceImageUrl: "", // 新增：用于保存人脸图片URL
        },
        dialogVisible: false,
      },
    };
  },
  methods: {
    fetchData() {
      const params = {
        UserName: this.state.searchForm.userName||'',
        Role: this.state.searchForm.role||'',
        page: this.state.currentPage,
        size: this.state.pageSize,
        OrganizationID: this.organizationID,
      };

      axios
          .get("/Manage/users", { params })
          .then((response) => {
            if (response.data.success) {
              this.state.users = response.data.data;
              // this.state.users = this.state.users.map(user => {
              //   return {
              //     ...user,
              //     // faceImageUrl: '/images/2/1.webp'
              //   };
              // });
              this.state.totalCount = response.data.total;
            } else {
              ElMessage.error(response.data.errorMsg || "操作失败");
            }
          })
          .catch((error) => {
            console.error("获取用户数据失败", error);
          });
    },
    handlePageChange(newPage) {
      this.state.currentPage = newPage;
      this.fetchData();
    },
    showAddUserDialog() {
      this.state.dialogVisible = true;
    },
    saveUser() {
      this.isedit = false;
      this.addOrUpdateUser();
    },
    addOrUpdateUser() {
      if (!this.isedit) {
        this.state.userForm.password = "123456";
        axios
            .post("/Manage/adduser", this.state.userForm, {
              params: {
                OrganizationID: this.organizationID,
              },
            })
            .then((response) => {
              if (response.data.success) {
                ElMessage.success("保存成功");
                this.fetchData();
              } else {
                ElMessage.error(response.data.errorMsg);
              }
            })
            .catch(() => {
              ElMessage.error("保存失败");
            });
      } else {
        axios
            .put("/Manage/updateuser", this.state.userForm)
            .then((response) => {
              if (response.data.success) {
                ElMessage.success("保存成功");
                this.fetchData();
              } else {
                ElMessage.error(response.data.errorMsg);
              }
            });
      }

      this.state.dialogVisible = false;
    },
    editUser(user) {
      if (user.role === "机构管理员") {
        ElMessage.error("无法编辑管理员用户");
        return; // 阻止编辑操作
      }
      this.isedit = true;
      this.state.userForm = { ...user };
      this.state.dialogVisible = true;
    },
    resetpassword(user) {
      if (user.role === "机构管理员") {
        ElMessage.error("无法重置管理员用户的密码");
        return; // 阻止重置操作
      }
      this.$confirm('确定要重置该用户的密码为 "123456" 吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
          .then(() => {
            axios
                .put("/Manage/updateuser", {
                  ...user,
                  password: "123456",
                })
                .then((response) => {
                  if (response.data.success) {
                    ElMessage.success("密码重置成功");
                    this.fetchData(); // 刷新数据
                  } else {
                    ElMessage.error(response.data.errorMsg || "密码重置失败");
                  }
                })
                .catch(() => {
                  ElMessage.error("密码重置失败");
                });
          })
          .catch(() => {
            ElMessage.info("已取消操作");
          });
    },
    deleteUser(user) {
      this.confirmDelete(user);
    },
    confirmDelete(user) {
      axios
          .delete(`/Manage/deleteuse/${user.userID}`)
          .then((response) => {
            if (response.data.success) {
              ElMessage.success("删除成功");
              this.fetchData();
            } else {
              ElMessage.error(response.data.errorMsg);
            }
          })
          .catch((error) => {
ElMessage.error("删除失败");
});
},
togglePasswordVisibility(row) {
// 切换密码的显示与隐藏
row.passwordVisible = !row.passwordVisible;
}
},
mounted() {
// 初始化时加载数据
this.fetchData();
}
};
</script>

<style scoped>
/* 在此处可以添加自定义样式 */
</style>
